import { createSlice } from '@reduxjs/toolkit';

export const functionalStatusSlice = createSlice({
  name: 'functionalStatus',
  initialState: {
    selectedFunctionalStatuses: { display: '', value: '', type: 'functional' },
    functionalInputText: '',
  },
  reducers: {
    setSelectedFunctionalStatuses: (state, action) => {
      state.selectedFunctionalStatuses = action.payload;
    },
    setFunctionalInputText: (state, action) => {
      state.functionalInputText = action.payload;
    },
  },
});

// slice for multiple value add in dropdown
// export const functionalStatusSlice = createSlice({
//   name: 'functionalStatus',
//   initialState: {
//     selectedFunctionalStatuses: [],
//     functionalInputText: '',
//   },
//   reducers: {
//     setSelectedFunctionalStatuses: (state, action) => {
//       const modifiedItems = action.payload.map(item => ({
//         ...item,
//         type: 'functional',
//       }));
//       state.selectedFunctionalStatuses = modifiedItems;
//     },
//     setFunctionalInputText: (state, action) => {
//       state.functionalInputText = action.payload;
//     },
//   },
// });

export const { setSelectedFunctionalStatuses, setFunctionalInputText } =
  functionalStatusSlice.actions;

export default functionalStatusSlice.reducer;
